import React from 'react'

function SvgTime(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" {...props}>
      <defs>
        <path
          id="time_svg__a"
          d="M8 14.667A6.674 6.674 0 011.333 8 6.674 6.674 0 018 1.333 6.674 6.674 0 0114.667 8 6.674 6.674 0 018 14.667M0 8a8 8 0 1016 0A8 8 0 000 8zm8-5.333c.368 0 .667.298.667.666v4H12a.667.667 0 010 1.334H8A.667.667 0 017.333 8V3.333c0-.368.299-.666.667-.666z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="time_svg__b" fill="#fff">
          <use xlinkHref="#time_svg__a" />
        </mask>
        <use fill="#00BEFF" xlinkHref="#time_svg__a" />
        <g fill="#FFF" mask="url(#time_svg__b)">
          <path d="M0 0h16v16H0z" />
        </g>
      </g>
    </svg>
  )
}

export default SvgTime
